import React from 'react';
import { Box, Carousel, Iconography, Typography } from '@lucid/lego';
import { useStore } from '../../store/store';
import { useGetLabels } from '../../hooks/useLabels';
import { convertToContentfulLocale } from '../../utils/tools';
import { NAVIGATION_LABELS_ID } from '../../config/constants';
import styles from './Dashboard.module.scss';
import QuickLinks from './QuickLinks/QuickLinks';
import dashboardCarousel1 from '../../assets/dashboard-carousel-1.webp';
import dashboardCarousel2 from '../../assets/dashboard-carousel-2.webp';
import dashboardCarousel3 from '../../assets/dashboard-carousel-3.webp';
import dashboardCarousel4 from '../../assets/dashboard-carousel-4.webp';

const CAROUSEL_SLIDES = [
  {
    url: dashboardCarousel4,
    alt: 'Dashboard Carousel 4',
  },
  {
    url: dashboardCarousel1,
    alt: 'Dashboard Carousel 1',
  },
  {
    url: dashboardCarousel2,
    alt: 'Dashboard Carousel 2',
  },
  {
    url: dashboardCarousel3,
    alt: 'Dashboard Carousel 3',
  },
];

const Dashboard: React.FC = () => {
  const theme = useStore((state) => state.theme);
  const locale = useStore((state) => state.locale);
  const language = useStore((state) => state.language);
  const userIdentity = useStore((state) => state.userIdentity);
  const displayName = userIdentity?.firstName || 'Guest';

  const { data: navigationLabels } = useGetLabels({
    id: NAVIGATION_LABELS_ID,
    locale: convertToContentfulLocale(locale),
    language,
  });

  return (
    <div className={styles.container}>
      <Carousel
        slides={CAROUSEL_SLIDES}
        theme={theme}
        autoPlayInterval={3000}
        height={500}
        dataTestId="dashboard-carousel"
      >
        <Box className={styles.overlayContainer} testId="carousel-overlay">
          <Box className={styles.title}>
            <Iconography category="brand" name="bear" color="white" size={64} />
            <Typography variant="headline" size="large" color="white" theme={theme} as="h1">
              Lucid Partner Portal
            </Typography>
          </Box>
          <Box className={styles.description}>
            <Typography variant="subtitle" size="large" color="primary-1" theme={theme}>
              Welcome {displayName}!
            </Typography>
          </Box>
        </Box>
      </Carousel>
      <QuickLinks theme={theme} labels={navigationLabels} />
    </div>
  );
};

export default Dashboard;
